import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup,FormControl,Validators, FormGroupDirective } from '@angular/forms';
import { ServicioGeneralService } from '../../../../servicios/servicio-general.service';

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.scss']
})
export class FormularioComponent implements OnInit {

  constructor(private servicioGeneralService:ServicioGeneralService) { }
  
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;

  @Input() active:number; // 0 = persona fisica, 1 = persona moral
  facturacionForm:FormGroup;
  colonia: Colonia[] = [];
  municipios: Municipio[] = [];
  estados: Estado[] = [];
  cpValido = '1';// bandera para validar si el cp es valido y arrojo información 
  bloquear:boolean = false;
  mensaje:Mensaje = {
    titulo:"",
    descripcion:"",
    clase:"",
    icono:"",
    href:""
  };

  ngOnInit(): void {
    this.facturacionForm = new FormGroup({
        'nombre':new FormControl('',[
          Validators.pattern('^([a-zA-Z]|ñ|Ñ|á|é|í|ó|ú|Á|É|Í|Ó|Ú| )*')
        ]),
        'app':new FormControl('',[
          Validators.pattern('^([a-zA-Z]|ñ|Ñ|á|é|í|ó|ú|Á|É|Í|Ó|Ú| )*')
        ]),
        'apm':new FormControl('',[
          Validators.pattern('^([a-zA-Z]|ñ|Ñ|á|é|í|ó|ú|Á|É|Í|Ó|Ú| )*')
        ]),
        'razon_social':new FormControl('',[
          Validators.pattern('^([a-zA-Z]|ñ|Ñ|á|é|í|ó|ú|Á|É|Í|Ó|Ú| )*')
        ]),
        'rfc':new FormControl('',[
        ]),
        'telefono':new FormControl('',[
          Validators.required,
          Validators.pattern('^[0-9]{10}$')
        ]),
        'entidad':new FormControl('',[
          Validators.required
        ]),
        'municipio':new FormControl('',[
          Validators.required,
        ]),
        'cp':new FormControl('',[
          Validators.required,
          Validators.pattern('^[0-9]{5}$')
        ]),
        'colonia':new FormControl('',[//localidad
            Validators.required
        ]),
        'calle':new FormControl('',[
          Validators.required,
          Validators.pattern('^([0-9]|[a-zA-Z]|ñ|Ñ|á|é|í|ó|ú|Á|É|Í|Ó|Ú| )*')
        ]),
        'num_ext':new FormControl('',[
          Validators.required,
          Validators.pattern('^[0-9]+$')
        ]),
        'num_int':new FormControl('',[
          Validators.pattern('^[0-9]+$')
        ]),
        'forma_pago':new FormControl('',[
          Validators.required,
          Validators.pattern('^([a-zA-Z]|ñ|Ñ|á|é|í|ó|ú|Á|É|Í|Ó|Ú| )*')
        ]),
        'email':new FormControl('',[
          Validators.required,
          Validators.pattern("^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$")
        ]),
        'numPoliza':new FormControl('',[
          Validators.required,
          Validators.pattern("^[0-9]{1,10}$")
        ]),
        'numRecibo':new FormControl('',[
          Validators.required,
          Validators.pattern("^[0-9]{1,10}$")
        ])
    });
  }

  /**
   * Metodo para enviar la factura al servidor
   */

  factura(){
    if(this.facturacionForm.valid){
      
  		this.bloquear = true;
      setTimeout(() => {
        var formData = new FormData();// 0 = persona fisica, 1 = persona moral
      
        formData.append('fisica_moral',(this.active == 1)+"");
        formData.append('nombre',(this.facturacionForm.controls.nombre.value == null)?'':this.facturacionForm.controls.nombre.value.toUpperCase().trim());
        formData.append('razon_social',(this.facturacionForm.controls.razon_social.value == null)?'':this.facturacionForm.controls.razon_social.value.toUpperCase().trim());
        formData.append('rfc',this.facturacionForm.controls.rfc.value.toUpperCase().trim());
        formData.append('telefono',this.facturacionForm.controls.telefono.value);
        formData.append('entidad',this.facturacionForm.controls.entidad.value.toUpperCase());
        formData.append('municipio',this.facturacionForm.controls.municipio.value.toUpperCase());
        formData.append('cp',this.facturacionForm.controls.cp.value);
        formData.append('colonia',this.facturacionForm.controls.colonia.value.toUpperCase().trim());
        formData.append('calle',this.facturacionForm.controls.calle.value.toUpperCase().trim());
        formData.append('num_ext',this.facturacionForm.controls.num_ext.value.toUpperCase().trim());
        formData.append('num_int',this.facturacionForm.controls.num_int.value.toUpperCase().trim());
        formData.append('numPoliza',this.facturacionForm.controls.numPoliza.value);
        formData.append('numRecibo',this.facturacionForm.controls.numRecibo.value);
        formData.append('forma_pago',this.facturacionForm.controls.forma_pago.value.toUpperCase().trim());
        formData.append('email',this.facturacionForm.controls.email.value.toLowerCase().trim());
        this.servicioGeneralService.factura(formData)
          .subscribe( (res:any) => {
              if(!res.error){
                this.enviaCorreo();
              }
              this.bloquear = false;
          },error => {
            this.bloquear = false;
            console.log(error);
            this.mensaje = {
              titulo: "Error",
              descripcion: "Ocurrió un error inesperado. Por favor intentelo más tarde.",
              clase: "alert-danger",
              icono: "Danger:",
              href: "#exclamation-triangle-fill"
            }
          }
        );
      }, 3000);
      
    }else{
      this.mensaje = {
        titulo: "Atención",
        descripcion: "Verifica que todos los campos esten llenos.",
        clase: "alert-warning",
        icono: "Warning:",
        href: "#exclamation-triangle-fill"
      }
    }
  }

  enviaCorreo(){
    let destinatario = "facturas@plusbarrent.com.mx";
    let asunto = "Nueva factura";
    let cuerpo =
        "<table border='1'>"+
        "<tr>"+
           "<th>Regimen</th>";
    if(this.active == 1){
      cuerpo += '<th>Razon social</th>';
    }else{
      cuerpo += "<th>Nombre</th>";
    }
    cuerpo +=   "<th>RFC</th>"+
                "<th>Telefono</th>"+
                "<th>Entidad</th>"+
                "<th>Municipio</th>"+
                "<th>CP</th>"+
                "<th>Colonia</th>"+
                "<th>Calle</th>"+
                "<th>Num ext</th>"+
                "<th>Num int</th>"+
                "<th>Num poliza</th>"+
                "<th>Num recibo</th>"+
                "<th>Forma de pago</th>"+
                "<th>Email</th>"+
        "</tr>"+
        "<tr>"+
          "<td>"+((this.active == 0)?"Persona fisica":"Persona moral")+"</td>";
    if(this.active == 0){ // true = persona moral, false = persona fisica
      cuerpo += "<td>"+this.acentos(this.facturacionForm.controls['nombre'].value.toUpperCase())+"</td>";
    }else{
      cuerpo += "<td>"+this.acentos(this.facturacionForm.controls['razon_social'].value.toUpperCase())+"</td>";
    }
      cuerpo += "<td>"+this.acentos(this.facturacionForm.controls["rfc"].value.toUpperCase())+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["telefono"].value)+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["entidad"].value.toUpperCase())+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["municipio"].value.toUpperCase())+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["cp"].value)+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["colonia"].value.toUpperCase())+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["calle"].value.toUpperCase())+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["num_ext"].value.toUpperCase())+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["num_int"].value.toUpperCase())+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["numPoliza"].value)+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["numRecibo"].value)+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["forma_pago"].value.toUpperCase())+"</td>"+
                "<td>"+this.acentos(this.facturacionForm.controls["email"].value+"</td>")+
        "</tr>"+

     " </table>";
    var formData = new FormData();

    formData.append("destinatario", destinatario);
    formData.append("asunto", asunto);
    formData.append("cuerpo", cuerpo);
    formData.append("origen", 'facturas@plusbarrent.com.mx');
    // se envia el correo al centro de facturación
    this.servicioGeneralService.enviaCorreo(formData)
        .subscribe( (res:any) => {
            if(!res.error){
              var formData = new FormData();
              formData.append("destinatario", this.facturacionForm.controls["email"].value);
              formData.append("asunto", "Solicitud de facturaci&oacute;n");
              formData.append("cuerpo", "<h2>Hemos recibido su solicitud de factura en un lapso de dos d&iacute;as habiles recibir&aacute; su informaci&oacute;n.</h2>");
              formData.append("origen", 'facturas@plusbarrent.com.mx');
              // se envia el correo al cliente
              this.servicioGeneralService.enviaCorreo(formData)
                .subscribe( (res:any) => {
                    if(!res.error){
                      setTimeout(() => {
                        this.facturacionForm.reset();
                        this.formGroupDirective.resetForm();
                      }, 0);
                      this.mensaje = {
                        titulo: "Gracias por facturar",
                        descripcion: "Su información a sido enviada, en un lapso de dos dias habiles recibira su factura.",
                        clase: "alert-success",
                        icono: "Success:",
                        href: "#check-circle-fill"
                      }
                    }
                    this.bloquear = false;
                },error => {
                  this.bloquear = false;
                    console.log(error);
                    this.mensaje = {
                      titulo: "Error",
                      descripcion: "Ocurrió un error inesperado. Por favor intentelo más tarde.",
                      clase: "alert-danger",
                      icono: "Danger:",
                      href: "#exclamation-triangle-fill"
                    }
                }
              );
            }
            this.bloquear = false;
        },error => {
          this.bloquear = false;
            console.log(error);
            this.mensaje = {
              titulo: "Error",
              descripcion: "Ocurrió un error inesperado. Por favor intentelo más tarde.",
              clase: "alert-danger",
              icono: "Danger:",
              href: "#exclamation-triangle-fill"
            }
        }
      );
  }

  acentos(str:string):string{
    let strF = '';
    for (var i = 0; i < str.length; ++i) {
      if(str[i] == 'Á'){
        strF += "&Aacute;";
      }else if(str[i] == 'É'){
        strF += "&Aacute;";
      }else if(str[i] == 'Í'){
        strF += "&Aacute;";
      }else if(str[i] == 'Ó'){
        strF += "&Aacute;";
      }else if(str[i] == 'Ú'){
        strF += "&Aacute;";
      }else if(str[i] == 'Ñ'){
        strF += "&Aacute;";
      }else{
        strF += str[i];
      }
    }
    return strF;
  }

  buscaCP(){
    if(this.facturacionForm.controls["cp"].value.length == 5){
      this.cpValido = '1';
      this.servicioGeneralService.busquedaByCp({'cp':this.facturacionForm.controls["cp"].value})
        .subscribe( (resp:any) => {
          //validamos que el codigo postal sea valido
          if(resp.colonias.length > 0 && resp.municipios.length > 0){
            this.colonia = [];
            this.facturacionForm.controls["municipio"].setValue("");
            this.facturacionForm.controls["entidad"].setValue("");
            for (let i = 0; i < resp.colonias.length; i++) {
              this.colonia.push(resp.colonias[i]);
            }
            if (this.colonia.length > 0) {
              this.facturacionForm.controls["colonia"].setValue(this.colonia[0].id);
              this.municipios = resp.municipios;
              for (let i = 0; i < resp.municipios.length; i++) {
                if (this.colonia[0].id_municipio == resp.municipios[i].id_municipio) {
                  this.facturacionForm.controls["municipio"].setValue(resp.municipios[i].municipio.toUpperCase());
                  this.facturacionForm.get('municipio').disable();
                  break;
                }
              }
              this.estados = resp.estados;
              for (let i = 0; i < resp.estados.length; i++) {
                if (this.colonia[0].id_estado == resp.estados[i].id) {
                  this.facturacionForm.controls["entidad"].setValue(resp.estados[i].estado.toUpperCase());
                  this.facturacionForm.get('entidad').disable();
                  break;
                }
              }
            }
          }else{
            this.cpValido = '0';
            this.facturacionForm.get('municipio').disable();
            this.facturacionForm.get('entidad').disable();
          }
        },error => {
          console.log(error);
        }
      );
    }
  }
}

interface Colonia {
  id: String;
  colonia: String;
  id_estado: String;
  id_municipio: String;
}
interface Municipio {
  id: String;
  municipio: String;
  id_estado: String;
  id_municipio: String;
}
interface Estado{
  id:String;
  estado:String;
}
interface Mensaje {
  titulo:String;
  descripcion:String;
  clase:String;
  icono:String;
  href:String;
}